import { getCountries } from 'common/api/companies';

import {
    FECH_COUNTRIES,
    FECH_COUNTRIES_FAILURE,
    FECH_COUNTRIES_SUCCESS,
} from '../actionTypes';
import { companiesActions } from '../reducer';

export default (companyId) => (dispatch) => {
    dispatch(companiesActions[FECH_COUNTRIES]());

    getCountries(companyId)
        .then((response) =>
            dispatch(
                companiesActions[FECH_COUNTRIES_SUCCESS](response.data.data),
            ),
        )
        .catch((error) =>
            dispatch(
                companiesActions[FECH_COUNTRIES_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
